import React, { useEffect, useState } from 'react';
import { Box, TextField, Typography, Paper, Divider, Button } from '@mui/material';
import axiosInstance from '../../../utils/axios';
const TextEditor = () => {
  const [settings, setSettings] = useState({
    text_start: '',
    text_city: '',
    text_product: '',
    text_packaging: '',
    text_district: '',
    text_no_req: '',
    text_order_form:'',
  });

  // Загружаем настройки при монтировании компонента
  const fetchBotText = async() => {
    const settings = await axiosInstance.get('/bots-settings/get')
    setSettings(settings.data)
    console.log(settings.data)
  }
  useEffect(() => {
    fetchBotText()
  }, []);

  // Обработчик изменения текста
  const handleChange = (event, field) => {
    setSettings({ ...settings, [field]: event.target.value });
  };

  // Сохранение настроек
  const handleSave = async () => {
    const settings1 = await axiosInstance.post('/bots-settings/update', settings)
    if(settings1.data.status) {
        alert("Настройки обновлены")
    } else {
        alert("Ошибка") 
    }


  };

  return (
    <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, bgcolor: 'background.paper' }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
        Редактор текста
      </Typography>

      <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
        Здесь вы можете редактировать текст для разных команд.
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Поле ввода для команды /start */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст при команде /start
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_start}
          onChange={(e) => handleChange(e, 'text_start')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>

      {/* Поле ввода для команды /city */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст перед выбором города
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_city}
          onChange={(e) => handleChange(e, 'text_city')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>

      {/* Поле ввода для команды /product */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст перед выбором товара
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_product}
          onChange={(e) => handleChange(e, 'text_product')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>

      {/* Поле ввода для команды /packaging */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст перед выбором фасовки
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_packaging}
          onChange={(e) => handleChange(e, 'text_packaging')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>

      {/* Поле ввода для команды /district */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст перед выбором района
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_district}
          onChange={(e) => handleChange(e, 'text_district')}
          placeholder="Введите текст для команды /district"
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>

      {/* Поле ввода для команды /no_req */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст при отсутствии реквизитов
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_no_req}
          onChange={(e) => handleChange(e, 'text_no_req')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>
      {/* Поле ввода для команды /no_req */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ fontWeight: 'bold', color: '#00796b', mb: 1 }}>
          Текст перед содержимым сформированного заказа
        </Typography>
        <TextField
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={settings.text_order_form}
          onChange={(e) => handleChange(e, 'text_order_form')}
          sx={{
            bgcolor: 'background.default',
            borderRadius: 1,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00796b',
              },
              '&:hover fieldset': {
                borderColor: '#004d40',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#004d40',
              },
            },
          }}
        />
      </Box>
      {/* Кнопка сохранения */}
      <Button variant="contained" color="primary" onClick={handleSave}>
        Сохранить настройки
      </Button>
    </Paper>
  );
};

export default TextEditor;
